import React from 'react';
import useTranslate from '../../Hooks/useTranslate';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { FlexBox } from '../../Components/FlexBox';

const RoundedTabs = function RoundedTabs({
  tabs,
  disableIcon = false,
  value,
  onChange,
  color = 'primary.main',
  textColor = 'inherit',
  fullWidth = false,
  size = 'medium',
  height,
  width,
}) {
  const translate = useTranslate();

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(event, newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      fullWidth={fullWidth}
      aria-label="toggle buttons as custom rounded tabs"
    >
      {tabs.map((tab, index) => (
        <ToggleButton
          disableRipple
          disableFocusRipple
          key={typeof tab === 'string' ? tab : tab?.label}
          size={size}
          value={typeof tab === 'string' ? index : tab?.value}
          selected={
            typeof tab === 'string' ? value === index : value === tab?.value
          }
          sx={{
            height: height,
            width: width,
            fontWeight: 600,
            minWidth: '160px',
            textTransform: 'capitalize',
            '&.Mui-selected': {
              color: textColor,
              backgroundColor: color,
              transition: 'background-color 0.2s ease-in-out',
              ':hover': {
                backgroundColor: color,
              },
            },
            borderRadius:
              // eslint-disable-next-line no-nested-ternary
              tabs.length === 1
                ? '24px 24px 24px 24px'
                : index === 0
                  ? '24px 0px 0px 24px'
                  : index === tabs.length - 1
                    ? '0px 24px 24px 0px'
                    : tabs.length === 1
                      ? '24px 24px 24px 24px'
                      : undefined,
          }}
        >
          <FlexBox
            sx={{
              gap: '4px',
              alignItems: 'center',
            }}
          >
            {!disableIcon &&
              (typeof tab !== 'string' && tab?.icon
                ? tab?.icon
                : typeof tab === 'string'
                  ? value === index && <DoneRoundedIcon />
                  : value === tab?.value && <DoneRoundedIcon />)}
            {translate(typeof tab === 'string' ? tab : tab?.label)}
          </FlexBox>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default RoundedTabs;
